enum LeasingAction {
  PurchaseOnline = 'purchaseOnline',
}

export default LeasingAction;
